export async function getContentType(url: string | undefined): Promise<string | null> {
  if (!url) {
    return null;
  }
  try {
    const response = await fetch(url, { method: 'HEAD' });

    return response.headers.get('Content-Type');
  } catch (error) {
    console.error('Error fetching content type:', error);

    return null;
  }
}
